import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,

  selector: 'lib-footer',
  imports: [MatDividerModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class LibFooterComponent {
  readonly currentYear = new Date().getFullYear();

  public footerItems = [
    {
      title: 'NCSEAA',
      labels: [
        {
          label: 'P.O. Box 41349',
          link: false,
          to: ''
        },
        {
          label: 'Raleigh, NC',
          link: false,
          to: ''
        },
        {
          label: '27629',
          link: false,
          to: ''
        },
        {
          label: '',
          link: false,
          to: ''
        },
        {
          label: '(919) 549-8614',
          link: false,
          to: ''
        }
      ]
    },
    {
      title: 'HELPFUL LINKS',
      labels: [
        {
          label: 'NCSEAA',
          link: true,
          to: 'https://www.ncseaa.edu'
        }
      ]
    },
    {
      title: 'INFORMATION',
      labels: [
        {
          label: 'Privacy Policy',
          link: true,
          to: 'https://k12.ncseaa.edu/media/21mlkpar/privacy-policy.pdf'
        },
        {
          label: 'Notice under the Americans with Disabilities Act',
          link: true,
          to: 'https://www.ncseaa.edu/accessibility/'
        },
        {
          label: 'Investor Information',
          link: true,
          to: 'https://www.ncseaa.edu/about/investor-information/'
        },
        {
          label: 'NC Open Budget',
          link: true,
          to: 'https://www.nc.gov/government/open-budget'
        },
        {
          label: 'Career Opportunities',
          link: true,
          to: 'https://www.ncseaa.edu/about/careers/'
        }
      ]
    }
  ];
}
